import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Save, Power } from "lucide-react";
import { toast } from "sonner";

export default function AdminToolFlags() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/tool-flags"); setItems(data.items || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const update = async (tool, patch) => {
    try { await api.put(`/admin/tool-flags/${tool}`, patch); toast.success(`Updated ${tool}`); await load(); }
    catch { toast.error("Update failed"); }
  };

  return (
    <div data-testid="admin-tool-flags">
      <div className="dms-label mb-3">Feature flags</div>
      <h1 className="text-2xl sm:text-3xl font-heading font-bold text-[#0A2342]">Tool feature flags</h1>
      <p className="mt-2 text-[#475569] text-[14.5px]">Disable broken tools instantly. Override tier requirements for promos.</p>

      <div className="mt-6 space-y-3">
        {loading ? <div className="text-[#64748B]"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Loading…</div> :
         items.map((f) => (
          <div key={f.tool} className="dms-card p-4 sm:p-5" data-testid={`flag-${f.tool}`}>
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <div className="font-mono text-[13px] text-[#0A2342] font-bold">{f.tool}</div>
                <div className="mt-1 text-[12px] text-[#64748B]">default tier: <span className="dms-badge">{f.default_tier}</span></div>
              </div>
              <div className="flex items-center gap-3">
                <label className="inline-flex items-center gap-2 text-[13px]">
                  <input data-testid={`toggle-${f.tool}`} type="checkbox" checked={f.enabled} onChange={(e) => update(f.tool, { enabled: e.target.checked })} />
                  <Power className="w-3.5 h-3.5" /> {f.enabled ? "Enabled" : "Disabled"}
                </label>
                <select value={f.override_tier || ""} onChange={(e) => update(f.tool, { override_tier: e.target.value || null })} className="dms-input text-[13px] py-1.5">
                  <option value="">(no override)</option>
                  <option value="basic">Force Basic-accessible</option>
                  <option value="pro">Force Pro-only</option>
                </select>
              </div>
            </div>
            <input
              data-testid={`maintenance-${f.tool}`}
              defaultValue={f.maintenance_message}
              onBlur={(e) => { if (e.target.value !== f.maintenance_message) update(f.tool, { maintenance_message: e.target.value }); }}
              placeholder="Maintenance message (shown when disabled, optional)"
              className="dms-input mt-3 text-[13.5px]"
            />
          </div>
         ))}
      </div>
    </div>
  );
}
